import { UserOutlined } from '@ant-design/icons';
import { Card, Collapse, Switch } from 'antd';
import Title from 'antd/lib/typography/Title';
import React, { FC } from 'react';
import { ListRemoveButton } from '../../../../../../lib/components/List/ListRemoveButton';
import {
	ContractManagerPermissions,
	ContractManagerPermissionsEntry,
	PERMISSION_LABELS,
	permissions_of,
} from '../../../model/ContractManagerPermissions';
import { AddContractManagerInput } from './AddContractManagerInput';

interface IProps {
	contract_managers: string[];
	contract_manager_permissions: ContractManagerPermissionsEntry[];
	on_add: (value: string) => void;
	on_remove: (value: string) => void;
	on_permission_change: (
		email: string,
		permission: keyof ContractManagerPermissions,
		value: boolean
	) => void;
}

export const ContractManagersList: FC<IProps> = ({
	contract_managers,
	contract_manager_permissions,
	on_add,
	on_remove,
	on_permission_change,
}) => (
	<Card>
		<Title level={5} className='uppercase'>
			Gestores de contrato
		</Title>

		<Collapse ghost expandIconPosition='left'>
			{contract_managers.map((email) => {
				const permissions = permissions_of(contract_manager_permissions || [], email);

				return (
					<Collapse.Panel
						key={email}
						header={
							<span className='flex items-center'>
								<UserOutlined className='text-blue-500 mr-2' />
								{email}
							</span>
						}
						extra={
							<span
								onClick={(event) => {
									event.stopPropagation();
								}}
							>
								<ListRemoveButton {...{ on_click: () => on_remove(email) }} />
							</span>
						}
					>
						<div className='pl-6'>
							<div className='text-gray-500 mb-2'>Permissões do Gestor</div>
							<div className='flex'>
								{PERMISSION_LABELS.map(({ key, label }) => (
									<div key={key} className='pr-8 mr-8 border-r border-gray-200 last:border-r-0'>
										<div className='mb-1'>{label}</div>
										<Switch
											{...{
												checked: permissions[key],
												onChange: (checked: boolean) =>
													on_permission_change(email, key, checked),
											}}
										/>
									</div>
								))}
							</div>
						</div>
					</Collapse.Panel>
				);
			})}
		</Collapse>

		<AddContractManagerInput
			{...{
				on_added: on_add,
			}}
		/>
	</Card>
);
